import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { UIProvider } from 'amo-styling-library'
import { AuthProvider } from './contexts/AuthContext'
import { ProtectedRoute } from './components/shared/ProtectedRoute'
import { ErrorBoundary } from './components/shared/ErrorBoundary'
import { UserRole } from './types/auth'
import LoginPageNew from './pages/LoginPageNew'
import RegisterPage from './pages/RegisterPage'
import StartPage from './pages/StartPage'
import TestPage from './pages/TestPage'
import InboxPage from './pages/InboxPage'
import DashboardPage from './pages/DashboardPage'
import ContainersPage from './pages/ContainersPage'
import TripsPage from './pages/TripsPage'
import SyncDashboardPage from './pages/SyncDashboardPage'

function App() {
  return (
    <React.Fragment>
      <ErrorBoundary>
        <UIProvider>
          <AuthProvider>
            <Routes>
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<LoginPageNew />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/test" element={<TestPage />} />
            <Route path="/start" element={
              <ErrorBoundary fallback={<div style={{padding: '20px'}}>Error loading Start Page. <a href="/login">Back to login</a></div>}>
                <ProtectedRoute>
                  <StartPage />
                </ProtectedRoute>
              </ErrorBoundary>
            } />
            <Route path="/inbox" element={
              <ErrorBoundary fallback={<div style={{padding: '20px'}}>Error loading Inbox. <a href="/start">Back to Start</a></div>}>
                <ProtectedRoute>
                  <InboxPage />
                </ProtectedRoute>
              </ErrorBoundary>
            } />
            <Route path="/user-management" element={
              <ErrorBoundary fallback={<div style={{padding: '20px'}}>Error loading User Management. <a href="/start">Back to Start</a></div>}>
                <ProtectedRoute allowedRoles={[UserRole.ADMIN, UserRole.MANAGER]}>
                  <DashboardPage />
                </ProtectedRoute>
              </ErrorBoundary>
            } />
            <Route path="/containers/*" element={
              <ErrorBoundary fallback={<div style={{padding: '20px'}}>Error loading Containers. <a href="/start">Back to Start</a></div>}>
                <ProtectedRoute>
                  <ContainersPage />
                </ProtectedRoute>
              </ErrorBoundary>
            } />
            <Route path="/import-export" element={
              <ErrorBoundary fallback={<div style={{padding: '20px'}}>Error loading Import / Export. <a href="/start">Back to Start</a></div>}>
                <ProtectedRoute>
                  <TripsPage />
                </ProtectedRoute>
              </ErrorBoundary>
            } />
            <Route path="/sync" element={
              <ErrorBoundary fallback={<div style={{padding: '20px'}}>Error loading Sync Dashboard. <a href="/start">Back to Start</a></div>}>
                <ProtectedRoute>
                  <SyncDashboardPage />
                </ProtectedRoute>
              </ErrorBoundary>
            } />
            {/* Legacy route for backwards compatibility */}
            <Route path="/dashboard" element={<Navigate to="/user-management" replace />} />
          </Routes>
        </AuthProvider>
      </UIProvider>
      </ErrorBoundary>
    </React.Fragment>
  )
}

export default App
